module.exports = __webpack_public_path__ + "img/trafic-sq.a2e55292.svg";